import '../InviteButtons.scss';
import { ReactComponent as ImportIcon } from 'images/icons/menu/Document.svg';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';
import { Button } from '@trackman/web-shared-components';

export const ImportStudentListButton = ({ intent }: { intent: 'primary' | 'secondary' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const setIsImportStudentListModalOpen = useOrganizationStore((state) => state.setIsImportStudentListModalOpen);

  const handleClick = () => {
    setIsImportStudentListModalOpen(true);
    if (location.pathname !== '/Organization/Students') {
      navigate('/Organization/Students');
    }
  };

  return (
    <Button
      startIcon={<ImportIcon />}
      label={t('ImportStudentList', { ns: 'studentsPage' })}
      className='organization-button'
      onClick={handleClick}
      intent={intent}
    />
  );
};

export default ImportStudentListButton;
